import {
  GET_APPROVAL,
  GET_APPROVAL_BY_DEPARTMENT_TYPE,
  CREATE_OR_EDIT_APPROVAL,
  GET_EXIST_APPROVAL
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_APPROVAL]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/approvals",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_APPROVAL_BY_DEPARTMENT_TYPE]({ dispatch }, params) {
      let url = "/kanri/approvals/get_by_department_type";
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_OR_EDIT_APPROVAL]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/approvals/create_or_edit_approval",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_EXIST_APPROVAL]({ dispatch }, params) {
      let url = "/kanri/approvals/get_exist_approval";
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
